export default __webpack_public_path__ + "static/media/bg.f0855b11.webp";